import {
  EmergencyContactRelationship,
  EmployeeWorkStatus,
  Ethnicity,
  PersonGender,
} from '@/types/api';
import { ContractStatus, ContractType, JobInfo } from '@/types/api/staffMember';

export const employeeWorkStatusOptions: EmployeeWorkStatus[] = ['Active', 'Inactive'];

export const genderOptions: PersonGender[] = [
  'Male',
  'Female',
  'Non-binary',
  'Don’t want to declare',
];

export const ethnicityOptions: Ethnicity[] = [
  'African American',
  'African/Black',
  'American Indian, Alaska Native, or other Indigenous',
  'Caucasian/White',
  'East Asian',
  'Hispanic and/or Latin American',
  'Middle Eastern/Arab',
  'Mixed Race/Mestizo',
  'Native Hawaiian or other Pacific Islander',
  'Other ethnic group',
  'South Asian',
];

export const emergencyRelationshipOptions: EmergencyContactRelationship[] = [
  'Brother',
  'Daughter',
  'Father',
  'Friend',
  'Husband',
  'Mother',
  'Other',
  'Partner',
  'Sister',
  'Son',
  'Wife',
];
export const contractTypeOptions: ContractType[] = ['Contractor', 'Employee', 'Freelance'];
export const contractStatusOptions: ContractStatus[] = ['Part-time', 'Full-time'];

export const getMostRecentStaffMemberActiveJob = (
  staffMemberJobInfo: JobInfo[]
): JobInfo | undefined => {
  const activeJobs = (staffMemberJobInfo || []).filter((currentJobInfo) => !currentJobInfo.toDate);
  if (!activeJobs.length) {
    return undefined;
  }

  return activeJobs?.reduce((mostRecent, jobInfo) => {
    const mostRecentFromDate = new Date(mostRecent.fromDate).getTime();
    const currentJobFromDate = new Date(jobInfo.fromDate).getTime();
    if (mostRecentFromDate > currentJobFromDate) {
      return mostRecent;
    }

    return jobInfo;
  });
};
